var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorVideoIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editor_video_ic_svg__clip0_1181_1850)",
    stroke: "#98BDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.517 2.167H3.483a1.817 1.817 0 00-1.816 1.816v13.034c0 1.003.813 1.816 1.816 1.816h13.034a1.817 1.817 0 001.816-1.816V3.982a1.817 1.817 0 00-1.816-1.817zM5.833 2.167v16.666M14.167 2.167v16.666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.667 10.5h16.666M1.667 6.333h4.166M1.667 14.666h4.166M14.167 14.666h4.166M14.167 6.333h4.166",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editor_video_ic_svg__clip0_1181_1850"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 9.75 10.25)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgEditorVideoIc;